module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Abo buchen.f7089c11.svg";